import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-nutrition-assignments-right-footer',
    styleUrls: ['./nutrition-assignments-right-footer.component.scss'],
    templateUrl: './nutrition-assignments-right-footer.component.html'
})
export class NutritionAssignmentsRightFooterComponent {

    @Input() disabledCancelButton: boolean;
    @Input() disabledSaveButton: boolean;
    @Input() showPublish: boolean;

    @Output() cancel = new EventEmitter<void>();
    @Output() submit = new EventEmitter<void>();
    @Output() publish = new EventEmitter<void>();

    ready: boolean;

    constructor() {}

    handleCancel(): void {
        this.cancel.next();
    }

    handleSubmit(): void {
        this.submit.next();
    }

    handlePublish(): void {
        this.publish.next();
    }

}
